export default "__VITE_ASSET__DFoi5_mQ__"